import { supportedLocales } from './i18n.js';
import { contentPageKeys, getContentPageByPath, getContentPagePath } from './contentPages.js';

const legalPaths = {
  privacy: 'privacy-policy',
  terms: 'terms-and-conditions',
};

export function getRoutePath(locale, type = null) {
  const localePrefix = locale === 'pl' ? '' : `/${locale}`;
  const pagePath = type
    ? legalPaths[type] ? `/${legalPaths[type]}` : getContentPagePath(locale, type)?.replace(localePrefix, '') ?? ''
    : '';
  return `${localePrefix}${pagePath}` || '/';
}

export function parseRoute(pathname) {
  if (pathname === '/') return { locale: 'pl', type: null, known: true };
  const contentRoute = getContentPageByPath(pathname);
  if (contentRoute) return { locale: contentRoute.locale, type: contentRoute.key, known: true };

  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];
  const hasLocalePrefix = supportedLocales.includes(firstSegment);
  const locale = hasLocalePrefix ? firstSegment : 'pl';
  if (hasLocalePrefix && segments.length === 1) return { locale, type: null, known: true };
  const pageSegment = segments[hasLocalePrefix ? 1 : 0];

  const type = pageSegment === 'privacy-policy' || pageSegment === 'privacy'
    ? 'privacy'
    : pageSegment === 'terms-and-conditions' || pageSegment === 'terms'
      ? 'terms'
      : null;

  const known = type !== null && (!hasLocalePrefix || locale !== 'pl');
  return { locale, type, known };
}

export function getAlternateRoutes(type = null) {
  return supportedLocales.map((locale) => ({
    locale,
    path: getRoutePath(locale, type),
  }));
}

export function getAllRouteTypes() {
  return [null, 'privacy', 'terms', ...contentPageKeys];
}
